import React, { use, useEffect, useRef, useState } from "react";
import { Form, Input, Spin, InputNumber, Divider, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save } from "../../../features/save/saveSlice";
import {
  fetchCounties,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation
} from "../../../features/fetch/fetchSlice";

import BreadCrumb from "../../../layout/BreadCrumb";
import { formatText } from "../../../utils";
const PartnerAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { activeObjCatPartners, activeObjPartners } = useSelector((state) => ({
    activeObjCatPartners: state.obj.activeObj["partners-category"],
    activeObjPartners: state.obj.activeObj["partners"],
  }));

  const { counties, subCounties, locations, subLocations } = useSelector(
    (state) => state.fetch
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/irrigation-partner-view");
  }

  const [countyName, setCountyName] = useState(
    activeObjPartners?.countyName ?? ""
  );

  const [subCountyType, setSubCountyType] = useState(
    activeObjPartners?.mipSubCountyId ?? ""
  );
  const handleSubCounty = async (value) => {
    await setSubCountyType(value);
    await dispatch(
      fetchSubCounties({
        subCountyId: value,
      })
    );
    await form.setFieldsValue({
      mipSubCountyId: "",
      mipLocationId: "",
      mipSubLocationId: "",
    });
  };

  const [locationType, setLocationType] = useState(
    activeObjPartners?.mipLocationId ?? ""
  );
  const handleLocation = async (value) => {
    await setLocationType(value);
    await dispatch(
      fetchLocation({
        locSubId: value,
      })
    );
    await form.setFieldsValue({ mipLocationId: "", mipSubLocationId: "" });
  };

  const [subLocationType, setSubLocationType] = useState(
    activeObjPartners?.mipSubLocationId ?? ""
  );
  const handleSubLocation = async (value) => {
    await setSubLocationType(value);
    await dispatch(
      fetchSubLocation({
        slocLocId: value,
      })
    );
    await form.setFieldsValue({ mipSubLocationId: "" });
  };

  const onFinish = async (data) => {
    data.ipId = activeObjPartners?.ipId ? activeObjPartners?.ipId : null;
    data.mipIrrigationPartnerType = activeObjCatPartners?.type;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/irrPart/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjPartners,
    });
  }, [activeObjPartners, form]);

  const initialFormValues = {
    ...activeObjPartners,
    majorCrop: activeObjPartners?.majorCrop
      ? activeObjPartners?.majorCrop?.split(",")
      : [],
  };

  useEffect(() => {
    dispatch(fetchCounties());
  }, []);

  useEffect(() => {
    if (activeObjPartners) {
      dispatch(
        fetchSubCounties({
          subCountyId: activeObjPartners?.mipCountyId,
        })
      );
      dispatch(
        fetchLocation({
          locSubId: activeObjPartners?.mipSubCountyId,
        })
      );
      dispatch(
        fetchSubLocation({
          slocLocId: activeObjPartners?.mipLocationId,
        })
      );
    }
  }, [activeObjPartners, form]);

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Irrigation Partners", path: "/irrigation-partner-list" },
          {
            title: `${activeObjCatPartners?.type} View`,
            path: "/irrigation-partner-view",
          },
          { title: `${activeObjCatPartners?.type} Add` },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">
          Add a New {activeObjCatPartners?.type}
        </div>
        <Divider />
        <div className="w-full mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="flex items-center gap-x-5">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">1</span>
              </div>
              <span className="paragraph_paragraph_bb13">Information</span>
            </div>

            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="mipName"
                label={`Name of ${formatText(activeObjCatPartners?.type)}`}
                rules={[
                  {
                    required: true,
                    message: "Please add name of MISP",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipDescription"
                label={"Description"}
                rules={[
                  {
                    required: true,
                    message: "Please add description",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipOfficePhoneNumber"
                label={"Office Phone Number"}
                rules={[
                  {
                    required: true,
                    message: "Please add office phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
              <Form.Item
                name="mipOfficialEmailAddress"
                label={"Official Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add official email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
              <Form.Item
                name="mipCeoOrMdName"
                label={"MD/CEO Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add MD/CEO name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
            </div>

            <div className="flex items-center gap-x-5 mt-[2.38rem]">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">2</span>
              </div>
              <span className="paragraph_paragraph_bb13">Contact person</span>
            </div>

            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="mipContactPerson"
                label={"Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipContactIdNumber"
                label="ID Number"
                rules={[
                  {
                    required: false,
                    message: "National ID is required",
                  },
                  {
                    validator(_, value) {
                      if (value && value.toString().length < 6) {
                        return Promise.reject(
                          "National ID must be at least 6 characters long"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                 
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="mipContactPhoneNumber"
                label={"Phone"}
                rules={[
                  {
                    required: true,
                    message: "Please add phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
              <Form.Item
                name="mipContactEmail"
                label={"Admin Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add admin email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
            </div>

            <div className="flex items-center gap-x-5 mt-[2.38rem]">
              <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
                <span className="paragraph_paragraph_bb08">3</span>
              </div>
              <span className="paragraph_paragraph_bb13">Location</span>
            </div>
            <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="mipCountyId"
                className=""
                label={"County"}
                rules={[
                  {
                    required: true,
                    message: "Please select county",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    counties?.length > 0 &&
                    counties?.map((item) => ({
                      value: item?.countyId,
                      label: item?.countyName,
                    }))
                  }
                  onChange={(value) => {
                    handleSubCounty(value);
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              {subCountyType && (
                <Form.Item
                  name="mipSubCountyId"
                  className=""
                  label={"SubCounty"}
                  rules={[
                    {
                      required: true,
                      message: "Please select subcounty",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      subCounties?.length > 0 &&
                      subCounties?.map((item) => ({
                        value: item?.subId,
                        label: item?.subCountyName,
                      }))
                    }
                    onChange={(value) => {
                      handleLocation(value);
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              {locationType && (
                <Form.Item
                  name="mipLocationId"
                  className=""
                  label={"Location"}
                  rules={[
                    {
                      required: true,
                      message: "Please select location",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      locations?.length > 0 &&
                      locations?.map((item) => ({
                        value: item?.locId,
                        label: item?.locLocation,
                      }))
                    }
                    onChange={(value) => {
                      handleSubLocation(value);
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              {subLocationType && (
                <Form.Item
                  name="mipSubLocationId"
                  className=""
                  label={"Sublocation"}
                  rules={[
                    {
                      required: true,
                      message: "Please select sublocation",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      subLocations?.length > 0 &&
                      subLocations?.map((item) => ({
                        value: item?.slocId,
                        label: item?.slocLocation,
                      }))
                    }
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                name="mipPhysicalLocation"
                className=""
                label={"Physical Location"}
                rules={[
                  {
                    required: true,
                    message: "Please give physical location",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipStreet"
                label={"Street"}
                rules={[
                  {
                    required: true,
                    message: "Please add Street",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipBuilding"
                label={"Building"}
                rules={[
                  {
                    required: true,
                    message: "Please add building",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="mipCity"
                label={"City"}
                rules={[
                  {
                    required: true,
                    message: "Please add city",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              {/* <Form.Item
                name="mipSecretariat"
                label={"Secretariat"}
                rules={[
                  {
                    required: true,
                    message: "Please add secretariat",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item> */}
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button
                    disabled={saving}
                    key="submit"
                    type="submit"
                    className="cstm-btn-2"
                  >
                    {saving ? (
                      <Spin />
                    ) : activeObjPartners?.ipId ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default PartnerAdd;
